export default __webpack_public_path__ + "static/media/arrowLeft.ebc3abf0.svg";